<!--
* @copyright Chianyu Inc., 2025 and onwards
* @author Liwg
* @date  2025/6/6 14:02
* @des
-->
<template>
  <div class="home-content">
    <img class="logo-title" src="@/assets/images/padcontrol_logo_title.png">
    <div class="row-flex">
      <div class="content-container">
        <div class="title-wrapper">
          <span class="top-title">{{ $t('padcontrol.appName') }}</span>
          <span class="top-subTitle">{{ $t('padcontrol.title0') }}</span>
        </div>
        <div class="img-container">
          <img class="home-preview" src="@/assets/images/padcontrol_home_preview1.png">
          <img class="home-preview" src="@/assets/images/padcontrol_home_preview2.png">
        </div>
      </div>
      <div class="pc-button-wrapper">
        <span class="button-text" @click="downloadAndroidApp">Android下载</span>
        <span class="button-text" @click="downloadIOSApp">iOS下载</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PadPcOfficalView',
  components: {
  },
  data () {
    return {}
  },
  methods: {
    downloadAndroidApp () {
      this.$emit('downloadAndroidApp')
    },
    downloadIOSApp () {
      this.$emit('downloadIOSApp')
    }
  }
}
</script>

<style scoped>

.row-flex {
  display: flex;
  flex-direction: row;
}

.home-content {
  display: flex;
  flex-direction: column;
  z-index: 1;
  flex: 1;
//background-color: yellow;
}

.logo-title {
  margin-left: 50px;
  margin-top: 30px;
  width: 250px;
  height: 60px;
}

.content-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-left: 240px;
//background-color: blue;
}

.title-wrapper {
  display: flex;
  flex-direction: column;
//background-color: green;
}

.top-title {
  color: white;
  font-size: 32px;
  font-weight: bold;
  margin-top: 50px;
}

.top-subTitle {
  margin-top: 10px;
  margin-bottom: 80px;
  color: white;
  font-size: 20px;
}

.img-container {
  display: flex;
  flex-direction: row;
}

.home-preview {
  padding-right: 50px;
  width: 280px;
  height: 560px;
}

.pc-button-wrapper {
  display: flex;
  flex-direction: column;
  width: 580px;
  align-items: center;
  justify-content: center;
//background-color: red;
}

.button-text {
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 8px;
  border-style: solid;
  border-color: #FFFFFF;
  border-width: 2px;
  color: #FFFFFF;
  width: 150px;
  height: 50px;
  font-size: 18px;
  line-height: 50px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
}

.button-text:active {
  background-color: #e3e5e5;
  color: #666666;
}
</style>




// WEBPACK FOOTER //
// src/pad-control/PadPcOfficalView.vue